import { includes } from 'lodash';
import * as L from 'leaflet';

export enum BaseLayer {
  Satellite = 'Satellite',
  Terrain = 'Terrain',
  Hybrid = 'Hybrid',
  Roadmap = 'Roadmap',
}

export function isSatelliteLike(type: BaseLayer | string): boolean {
  return includes([BaseLayer.Satellite, BaseLayer.Hybrid], type);
}

export function addGoogleMapLayers(map: L.Map, defaultLayer?: 'hybrid' | 'roadmap'): BaseLayer {
  const gridLayer = L.gridLayer as any;
  const googleMapSatellite = gridLayer.googleMutant({ type: 'satellite' });
  const googleMapTerrain = gridLayer.googleMutant({ type: 'terrain' });
  const googleMapHybrid = gridLayer.googleMutant({ type: 'hybrid' });
  const googleMap = gridLayer.googleMutant({ type: 'roadmap' });
  if (defaultLayer === 'hybrid') {
    map.addLayer(googleMapHybrid);
  } else {
    map.addLayer(googleMap);
  }
  const layersControl = L.control.layers({
    [BaseLayer.Satellite]: googleMapSatellite,
    [BaseLayer.Terrain]: googleMapTerrain,
    [BaseLayer.Hybrid]: googleMapHybrid,
    [BaseLayer.Roadmap]: googleMap,
  });
  map.addControl(layersControl);

  return BaseLayer.Roadmap;
}
